import { MLS, MLSID } from '@aloft/toolkit-shared';

export function hasAtLeastOneActiveMLS(mlsIDs: string[]): boolean {
  return mlsIDs.filter((id) => MLS[id as MLSID].isActive).length > 0;
}
